import { Button, type ButtonProps } from './button';
import { Icons } from '../icons';
import { cn } from '@/lib/cn';

interface LoaderButtonProps extends ButtonProps {
  isLoading?: boolean;
}

export function LoaderButton({
  isLoading,
  disabled,
  children,
  className,
  ...rest
}: LoaderButtonProps) {
  return (
    <Button
      {...rest}
      disabled={isLoading || disabled}
      className={cn('relative', className)}
    >
      {isLoading && (
        <span className='absolute inset-0 flex items-center justify-center'>
          <Icons.loader className='size-4 animate-spin' />
        </span>
      )}
      {isLoading ? (
        <span className={cn('invisible flex items-center', className)}>
          {children}
        </span>
      ) : (
        children
      )}
    </Button>
  );
}
